import { DirectiveBase } from '../angular-directive-base.directive';

/**
 * Allows for files to be selected and uploaded
 */
export class FileUpload extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'E';
    this.templateUrl = 'app/angularJS/components/file_upload/file-upload.html';
    this.scope = {
      uploadObject: '=',
      isUploaderDisabled: '=',
      allowedFileTypes: '@',
      showSubErrorMessage: '@',
      onFileImported: '&',
      autoUpload: '='
    };

    this.controller = 'FileUploadController';
    this.controllerAs = 'vm';
    this.bindToController = true;
  }
}